import { motion } from "framer-motion";
import Button from "../../ui/Button";
import "./Homehero.css";

// Hero content lines

export default function HomeHero() {
  return (
    <div className="homeHero">
      <video
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
        className="video-background"
      >
        <source
          src="https://res.cloudinary.com/dcedehnw3/video/upload/v1746707998/Video_for_hero_section_aocobh.mp4"
          type="video/mp4"
        />
      </video>
      <div className="video-overlay"></div>

      <motion.div
        className="homeHero__content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
       
	<h1 className="responsive-title">10年以上の金融業界向けシステム運用保守が証明する、揺るぎないIT品質。</h1>

        <motion.p
          className="text-gray-300 text-[18px] font-light leading-[1.8] mt-4 max-w-3xl tracking-wide"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          FinTech領域で10年以上にわたり、インドから24/365のマネージドサービスを提供してきた確かな実績を基盤に、
ソフトウェア開発からオフショア活用まで一貫したIT支援を行います。
        </motion.p>

        <motion.p
          className="text-gray-300 text-[18px] font-light leading-[1.8] mt-4 max-w-3xl tracking-wide"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.4, duration: 0.8 }}
        >
          DG FutureTechは、India 信頼性の高いサポート、革新的なソリューション、業界に特化したコンサルティングにより、テクノロジーをより身近なものにし、ビジネスパフォーマンスを向上させることで、24時間365日のシームレスな運用を保証します。
        </motion.p>
	<motion.div
          className="homeHero__button-container mt-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.8, duration: 0.6 }}
        >
          <Button
            onClick={() =>
            window.open(
              "https://outlook.office.com/bookwithme/user/e005431dda2242eca3b9d90fe7411a20@dgfuturetech.com/meetingtype/VNymjJqM90q3bWWARqKoFA2?anonymous&ep=mCardFromTile"
            )
            }
          >
            【無料】オンライン打合せを予約する
          </Button> 
        </motion.div>
        </motion.div>
    </div>
  );
}
